export const AllEventsFilter = {
  label: `all events`,
  value: {value: `all events`},
};
